import React, { FC, useMemo } from 'react'
import { Text, ListItem } from '@chakra-ui/react'
import { usePrimaryGradient } from '../../../theme'

export const INVALID_OPACITY = 0.25
export const VALID_OPACITY = 1

export const ValidationListItem: FC<{
  isValid: boolean
  text: string
}> = ({ isValid, text }) => {
  const bulletColor = usePrimaryGradient()

  const itemStyle = useMemo(
    () => ({
      bgGradient: bulletColor,
      borderRadius: '100%',
      content: '" "',
      display: 'inline-block',
      height: 1.5,
      marginRight: '.5em',
      textIndent: '-.7em',
      width: 1.5,
    }),
    [bulletColor],
  )

  const opacity = useMemo(
    () => (isValid ? VALID_OPACITY : INVALID_OPACITY),
    [isValid],
  )

  return (
    <ListItem
      _before={itemStyle}
      data-testid="validation-list-item"
      opacity={opacity}>
      <Text as="span">{text}</Text>
    </ListItem>
  )
}
